"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _lodash = _interopRequireDefault(require("lodash"));
var _basic = _interopRequireDefault(require("./_basic"));
const getErrorMessage = e => {
  const responseData = _lodash.default.get(e, 'response.data');
  const errorMessage = _lodash.default.get(e, 'message');
  const responseError = _lodash.default.get(responseData, 'error', responseData);
  return _lodash.default.isString(responseError) ? responseError : _lodash.default.isEmpty(responseError) ? errorMessage : JSON.stringify(responseError);
};
class HitlSLSApi extends _basic.default {
  /**
   * Represents a HitL SLS Api.
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      hitlApiUrl,
      accountId,
      timeout
    } = _ref;
    super({
      userTokenFactory
    });
    this.hitlApiUrl = hitlApiUrl;
    this.accountId = accountId;
    this.axios = _axios.default.create({
      ...(timeout && {
        timeout
      })
    });
  }
  getUrl(url) {
    return `${this.hitlApiUrl}/api/v1/${url}`;
  }
  async _callApi(_ref2) {
    let {
      url,
      data,
      queryParams,
      method
    } = _ref2;
    const {
      data: response
    } = await this.axios({
      url: this.getUrl(url),
      method,
      data,
      params: _lodash.default.mapValues(queryParams, value => _lodash.default.isArray(value) ? JSON.stringify(value) : value),
      headers: {
        Authorization: this.userToken,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).catch(e => {
      throw new Error(getErrorMessage(e));
    });
    return response;
  }

  /**
   * @param {String} param0.filterId id of filter
   * @returns {Object} filter
   */
  async getFilter(_ref3) {
    let {
      filterId
    } = _ref3;
    return this._callApi({
      method: 'get',
      url: '/filters',
      queryParams: {
        filterId
      }
    });
  }

  /**
   * @returns {Array} filters list
   */
  async getFilters() {
    return this._callApi({
      method: 'get',
      url: '/filters'
    });
  }

  /**
   * @param {String} param0.name name of filter
   * @param {Boolean} param1.isCommon common or personal filter
   * @param {Object} param2.settings filter settings
   * @param {Boolean} param3.isDefault default for apply common filter
   * @param {Number} param4.order order of filter
   * @returns {Object} added filter
   */
  async createFilter(_ref4) {
    let {
      name,
      isCommon,
      settings,
      isDefault,
      order
    } = _ref4;
    return this._callApi({
      method: 'post',
      url: '/filters',
      data: {
        name,
        isCommon,
        settings,
        isDefault,
        order
      }
    });
  }

  /**
   * @param {String} param0.filterId id of filter
   * @param {String} param1.name name of filter
   * @param {Boolean} param2.isCommon common or personal filter
   * @param {Object} param3.settings filter settings
   * @param {Boolean} param4.isDefault default for apply common filter
   * @param {Number} param5.order order of filter
   * @returns {Object} added filter
   */
  async updateFilter(_ref5) {
    let {
      filterId,
      name,
      isCommon,
      settings,
      isDefault,
      order
    } = _ref5;
    return this._callApi({
      method: 'put',
      url: '/filters',
      data: {
        filterId,
        name,
        isCommon,
        settings,
        isDefault,
        order
      }
    });
  }

  /**
   * @param {String} param0.filterId id of filter
   * @returns {Object} delete stats
   */
  async deleteFilter(_ref6) {
    let {
      filterId
    } = _ref6;
    return this._callApi({
      method: 'delete',
      url: '/filters',
      queryParams: {
        filterId
      }
    });
  }

  /**
   * @param {Array} param0.categories categories of settings
   * @param {Boolean} param1.isCommon is common setting
   * @returns {Array} agents settings (notifications, rwsAssistant)
   */
  async getSettings(_ref7) {
    let {
      categories,
      isCommon
    } = _ref7;
    return this._callApi({
      method: 'get',
      url: '/settings',
      queryParams: {
        categories,
        isCommon
      }
    });
  }

  /**
   * @param {Boolean} param0.isCommon is common setting
   * @param {Object} param1.data settings data
   * @returns {Object} create/update stats
   */
  async createOrUpdateSettings(_ref8) {
    let {
      isCommon,
      data
    } = _ref8;
    return this._callApi({
      method: 'put',
      url: '/settings',
      queryParams: {
        isCommon
      },
      data: {
        data
      }
    });
  }

  /**
   * @param {Array} param0.categories categories of canned message
   * @param {Boolean} param1.isCommon is common canned message
   * @param {Boolean} param2.ignoreRuleTags ignore rule tags in logic of canned message list
   * @returns {Array} canned messages list
   */
  async getCannedMessagesList(_ref9) {
    let {
      categories,
      isCommon,
      ignoreRuleTags
    } = _ref9;
    return this._callApi({
      method: 'get',
      url: '/canned-messages',
      queryParams: {
        categories,
        isCommon,
        ignoreRuleTags
      }
    });
  }

  /**
   * @param {String} param0.messageId id of canned message
   * @returns {Object} canned message
   */
  async getCannedMessage(_ref10) {
    let {
      messageId
    } = _ref10;
    return this._callApi({
      method: 'get',
      url: '/canned-messages',
      queryParams: {
        messageId
      }
    });
  }

  /**
   * @param {String} param0.text text of canned message
   * @param {String} param1.label short description of canned message
   * @param {Array} param2.category category of canned message
   * @param {Boolean} param3.isCommon is common canned message
   * @param {Array} param4.ruleTags tags that allow to get message
   * @param {String} param5.fileKeys file name attached to message
   * @returns {Object} added canned message
   */
  async createCannedMessage(_ref11) {
    let {
      text,
      label,
      category,
      isCommon,
      ruleTags,
      fileKeys
    } = _ref11;
    return this._callApi({
      method: 'post',
      url: '/canned-messages',
      data: {
        text,
        label,
        category,
        isCommon,
        ruleTags,
        fileKeys
      }
    });
  }

  /**
   * @param {String} param0.messageId id of canned message
   * @param {String} param1.text text of canned message
   * @param {String} param2.label short description of canned message
   * @param {Array} param3.category category of canned message
   * @param {Array} param4.ruleTags tags that allow to get message
   * @param {String} param5.fileKeys file name attached to message
   * @returns {Object} update stats
   */
  async updateCannedMessage(_ref12) {
    let {
      messageId,
      text,
      label,
      category,
      ruleTags,
      fileKeys
    } = _ref12;
    return this._callApi({
      method: 'put',
      url: '/canned-messages',
      data: {
        messageId,
        text,
        label,
        category,
        ruleTags,
        fileKeys
      }
    });
  }

  /**
   * @param {String} param0.messageId id of canned message
   * @returns {Object} delete stats
   */
  async deleteCannedMessage(_ref13) {
    let {
      messageId
    } = _ref13;
    return this._callApi({
      method: 'delete',
      url: '/canned-messages',
      queryParams: {
        messageId
      }
    });
  }
}
var _default = HitlSLSApi;
exports.default = _default;